import { CustomsUserType } from '@packlink/packlink-sdk';
import { translateSelectOption } from '../utils/select.js';

const userTaxTypeOptions = [{
  value: CustomsUserType.COMPANY,
  label: 'customs-form.vat-status.company'
}, {
  value: CustomsUserType.PRIVATE_PERSON,
  label: 'customs-form.vat-status.particular'
}];
function getInitialClientTaxFormValues(taxInformation, t) {
  return {
    vatStatus: taxInformation !== null && taxInformation !== void 0 && taxInformation.company ? translateSelectOption(userTaxTypeOptions[0], t) : undefined,
    company: taxInformation === null || taxInformation === void 0 ? void 0 : taxInformation.company,
    taxId: '',
    vatNumber: '',
    eori: ''
  };
}

export { getInitialClientTaxFormValues, userTaxTypeOptions };
//# sourceMappingURL=TaxFormTypes.js.map
